import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const ComputerScienceHeader = () => {
  return (
    <CourseHeader
      title="Computer"
      highlight="Science"
      subtitle="Innovate. Discover. Transform."
      backgroundImage="https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80"
    />
  );
};

export default ComputerScienceHeader;
